import { Stack } from '@mui/material';
import Stat from 'views/Components/Shared/Components/StatCard/Stat';
import StatCard from 'views/Components/Shared/Components/StatCard/StatCard';
import StatDescription from 'views/Components/Shared/Components/StatCard/StatDescription';
import { useMemo } from 'react';

import useCurrentMasterCountry from 'views/Components/Shared/hooks/useCurrentMasterCountry';
import { MarketplaceIcons } from '../utils';
import useChannelsProductMasterData from '../../Queries/ProductMasterChannelsQuery';
import useProductMasterData from '../../Queries/productMasterDataQuery';

export default function ProductMasterStats() {
	const { data } = useProductMasterData();
	const mainCountry = useCurrentMasterCountry();
	const mainCountryId = mainCountry?.id;
	const { data: channels } = useChannelsProductMasterData();

	const filteredChannel = useMemo(() => {
		return (
			channels?.filter((channel) => channel.country_id === mainCountryId) ?? []
		);
	}, [channels, mainCountryId]);

	const getCountKey = (sname) => {
		const keyMap = {
			AMZN: 'count_amzn',
			OFF: 'count_b2b',
			VTEX: 'count_vtex',
			MELI: 'count_meli',
		};
		return keyMap[sname] || `count_${sname.toLowerCase()}`;
	};

	return (
		<Stack
			spacing={4}
			direction="row"
			sx={{
				overflowX: 'auto',
			}}
		>
			<StatCard
				statDescription={
					<StatDescription
						width="60px"
						height="60px"
						description="Total de productos:"
						maxWidth="200px"
					/>
				}
				stat={<Stat stat={data?.count} />}
			/>
			{filteredChannel.map((channel) => {
				const countKey = getCountKey(channel.marketplace_sname);

				const productCount = data ? data[countKey] ?? 0 : 0;

				return (
					<StatCard
						key={channel.marketplace_id}
						statDescription={
							<StatDescription
								icon={MarketplaceIcons[channel.marketplace_sname]}
								description={`SKUs ${
									(channel.marketplace_sname === 'AMZN' && 'AMZ') ||
									(channel.marketplace_sname === 'OFF' && 'B2B') ||
									channel.marketplace_sname
								}`}
								width="60px"
								height="60px"
							/>
						}
						stat={<Stat stat={productCount} />}
					/>
				);
			})}
		</Stack>
	);
}
